import { gql } from '@apollo/client';

export const APP_TOKEN = 'polystox-admin';

export const types = Object.freeze({
  LIVE: 'LIVE',
  FORWARD: 'FORWARD',
  FOREIGN: 'FOREIGN',
});

export const OFFER_AND_DEMAND_TYPE = Object.freeze({
  OFFERTYPE: 'offerType',
  DEMANDTYPE: 'demandType',
});

export const indiaCallingCodeId = '+91';

export const LOGISTIC_TYPE = Object.freeze({
  POLYSTOX: 'Polystox',
  SELF: 'Self',
});

export const GRADES_QUERY = gql`
  query grades(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    grades(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      grades {
        name
        id
      }
      totalCount
      totalPages
    }
  }
`;
